import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SpeciesEnum } from '@/api/rest/resources/types/fact';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const SpeciesGradientExplainer = ({ species }: { species: SpeciesEnum }) => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='species-gradient-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t(`shared.ncaDetail.details.speciesGradient.explainers.${species}.howDoWeMeasure.title`)}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={t(`shared.ncaDetail.details.speciesGradient.explainers.${species}.howDoWeMeasure.body`)}
            />
          </ExplainerBody>
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
